module.exports = function (n) { return n - Math.max(Math.log2(n), n / 2); };